import StaffAssignedIcon from 'components/elements/icons/StaffAssignedIcon'
import InformationContent from 'components/elements/items/InformationContent'
import RequestedTemplate from 'components/templates/RequestedTemplate'
import React from 'react'
import { QnStatesProps } from 'states/QnState'
import { StatesProps } from 'utils/commonHooks'

/**
 * QN-0013: 再手配通知画面
 */
const ReAssigned: React.FC<StatesProps> = (props: QnStatesProps) => {
  const { state } = props
  return (
    <RequestedTemplate
      title={'再手配通知画面'}
      content={
        <InformationContent
          items={[
            {
              icon: <StaffAssignedIcon />,
              marginBottom: '15px',
            },
            {
              message: '画面を更新中です',
              large: true,
            },
          ]}
        />
      }
      state={state}
    />
  )
}

export default ReAssigned
